export default [{
    path: '/alert-policies',
    component: () => import('../pages/alert-policies/Index.vue'),
    children: [
        {
            path: '',
            name: 'alert-policies/list',
            meta: {
                parentPath: '/alerting',
                layout: 'default',
                breadcrumb: [{ label: 'Alerting', to: { name: 'incidents/summary' } }, { label: 'Alert Policies' }],
            },
            component: () => import('../pages/alert-policies/AlertPolicies.vue'),
        },
        {
            path: 'new',
            name: 'alert-policies/create',
            meta: {
                parentPath: '/alerting',
                layout: 'default',
                breadcrumb: [
                    { label: 'Alerting', to: { name: 'incidents/summary' } },
                    { label: 'Alert Policies', to: { name: 'alert-policies/list' } },
                    { label: 'New Alert Policy' },
                ],
            },
            component: () => import('../pages/alert-policies/AlertPolicyEdit.vue'),
        },
        {
            path: ':id',
            name: 'alert-policies/detail',
            meta: {
                parentPath: '/alerting',
                layout: 'default',
                breadcrumb: [
                    { label: 'Alerting', to: { name: 'incidents/summary' } },
                    { label: 'Alert Policies', to: { name: 'alert-policies/list' } },
                    { label: 'Alert Policy Detail' },
                ],
            },
            component: () => import('../pages/alert-policies/AlertPolicyDetail.vue'),
        },
        {
            path: ':id/edit',
            name: 'alert-policies/edit',
            meta: {
                parentPath: '/alerting',
                layout: 'default',
                breadcrumb: [
                    { label: 'Alerting', to: { name: 'incidents/summary' } },
                    { label: 'Alert Policies', to: { name: 'alert-policies/list' } },
                    { label: 'Edit Alert Policy' },
                ],
            },
            component: () => import('../pages/alert-policies/AlertPolicyEdit.vue'),
        },
    ],
}];
